<span [class]="styleClass"> <i [class]="iconClass"></i> {{ title }}</span>